import { Box, Skeleton } from "@mui/material";

export function KanbanCardSkeleton() {
    return (
        <Box padding={2}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Skeleton variant="text" width={150} />
                <Skeleton variant="text" width={20} />

            </div>
            <Skeleton variant="text" width={200} />
            <Skeleton variant="text" width={150} />
            <Skeleton variant="text" width={150} />
        </Box>
    )
}